module.exports = __webpack_public_path__ + "static/media/move-along-nothing-to-see-here.6e20613a.jpg";